// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"hkClBMK6INp0"};